module.exports = __webpack_public_path__ + "img/tiktok.cb2957b2.png";